import React from "react";
import * as echarts from "echarts";
import ReactECharts from "echarts-for-react";
import { useState } from "react";
import { useEffect } from "react";
import clienteAxios from "../../config/axios";

export default (props) => {
  const { title, data } = props;
  console.log(data);

  const option = {
    backgroundColor: "#fff",
    title: {
      text: title,
      left: "center",
    },
    tooltip: {
      trigger: "item",
    },
    legend: {
      orient: "vertical",
      left: "left",
    },
    series: [
      {
        type: "pie",
        radius: "50%",
        data: data,
        label: {
          formatter: "{b} ({d}%)",
        },
        emphasis: {
          itemStyle: {
            shadowBlur: 10,
            shadowOffsetX: 0,
            shadowColor: "rgba(0, 0, 0, 0.5)",
          },
        },
      },
    ],
  };

  return <ReactECharts option={option} />;
};
